export default __webpack_public_path__ + "static/media/logo-inverted-minimized.fc051270.svg";